import { render } from "./PokemonPicture.vue?vue&type=template&id=b7a41a86&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=b7a41a86&scoped=true&lang=css"

import exportComponent from "/home/trimogesimo/a-subir/Pokemon_Game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a41a86"]])

export default __exports__